<div class="card-head">
  <h2>Timeline</h2>
  <div class="flex-fill"></div>
</div>

<div class="card-body">
  @if (events.length === 0) {
    <p class="text-muted fst-italic my-2 text-center">No events recorded for this transaction.</p>
  }

  <ol class="tl" data-test="tx-detail-event-timeline">
    @for (event of events; track event.timestamp + event.eventType) {
      <li class="tl-item" [ngClass]="'tl-' + event.outcome">
        <span class="tl-icon">
          <fa-icon [icon]="eventIcon(event)" size="xs"></fa-icon>
        </span>
        <div class="tl-top">
          <span class="tl-title">{{ event.title }}</span>
          <span class="tl-when upper-time">{{ event.timestamp | date: 'dd/MM/yy h:mm:ss a' }}</span>
        </div>
        @if (event.description) {
          <div class="tl-sub">{{ event.description }}</div>
        }
        @if (eventData(event).length > 0) {
          <div class="tl-meta">
            @for (item of eventData(event); track item.key) {
              <span>{{ item.key }}: <b>{{ item.value }}</b></span>
            }
          </div>
        }
      </li>
    }
  </ol>
</div>
